var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44835 11.6278H0.986816V4.24316H3.44835V11.6278Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21027 2.60222H2.19628C1.46171 2.60222 0.986816 2.05494 0.986816 1.37099C0.986816 0.67258 1.47617 0.140625 2.22469 0.140625C2.9732 0.140625 3.43415 0.67258 3.44835 1.37099C3.44835 2.05494 2.9732 2.60222 2.21027 2.60222Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4739 11.6276H10.0551V7.76756C10.0551 6.798 9.70502 6.1364 8.82937 6.1364C8.16109 6.1364 7.76304 6.58242 7.58822 7.0132C7.52426 7.16759 7.50856 7.38269 7.50856 7.59833V11.6278H5.08936C5.08936 11.6278 5.12124 5.0898 5.08936 4.41278H7.50856V5.43472C7.82961 4.94346 8.4046 4.24316 9.68889 4.24316C11.2806 4.24316 12.474 5.27459 12.474 7.49073L12.4739 11.6276Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIn);
export default __webpack_public_path__ + "static/media/footer-in.5e50955d3866572b0b0b6e570273dc90.svg";
export { ForwardRef as ReactComponent };